// extracted by mini-css-extract-plugin
module.exports = {"card":"ResetPassword_card__1c-Eh","titleStyle":"ResetPassword_titleStyle__3WfJV","linkStyle":"ResetPassword_linkStyle__zWlam"};